import React, { useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { TablePagination } from '@material-ui/core';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import API_PATH from "../../constants/config.json";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useHistory } from 'react-router-dom';
import { clearCookie } from '../../functions/Auth';
import CircularProgress from '@material-ui/core/CircularProgress';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Css code start ...
const useStyles = makeStyles((theme) => ({
  filterTable: {
    width:'100%',
    float:'left',
    position:'relative',
    '& .MuiTableCell-head': {
      fontWeight: '600',
      fontSize: '14pt',
      background: '#fff',
      color: '#000',
      border: '1px solid #d1d1d1',
      padding: '5px',
    },
    '& .MuiFormControl-root': {
      border: '1px solid #24618E',
      borderRadius: '3px 3px 3px 3px',
      paddingLeft: '0px',
      position: 'absolute',
      padding: ' 0px 6px 0px 0px',     
      '@media only screen and (max-width: 3500px)': {
        width: '400px',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '650px',
        '& input': {
          fontSize: '24pt',
        }
      },
      zIndex: 1,
      '& .MuiIconButton-root.Mui-disabled': {
        color: '#fff',
      },
      '& :hover .MuiInputAdornment-positionEnd button': {
        color: '#24618E !important',
        fontWeight: '600 !important',
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInputAdornment-positionStart': {
      background: '#24618E',
      color: '#fff',
      paddingLeft: '5px',
      borderRadius: '0px 3px 3px 0px',
      position: 'relative',
      left: '100%',
      '@media only screen and (max-width: 3500px)': {
        height: '32px',
        width: '43px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '60px',
        width: '70px',
        maxHeight: '60px',
        marginLeft: '-28px',
      },
    },
    '& .MuiToolbar-root ': {
      paddingLeft: '0px',
      minHeight: '45px !important',
    },
    '& .MuiInput-root': {
      left: '-30px',
    },
    '& .MuiInputAdornment-positionStart svg': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '31px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '50px !important',
        marginLeft: '5px',
      },
    },
    '& td': {
      padding: '5px',
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
      },
    },
    '& th': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
        padding: '5px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
        padding: '20px 5px 15px !important',
      },
    },
    '& tr:nth-child(odd)': {
      backgroundColor: '#f2f2f2'
    },
    '& td:first-child': {
      color: '#CC0000 !important',
      fontWeight: '600 !important',
    },
    '& table': {
      borderRight: '1px solid #D7D7D7',
      '@media only screen and (min-width: 3501px)': {
        marginTop: '35px',
      },
    },
    '& .MuiTableCell-head:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTableCell-body:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTablePagination-select': {
      color: '#000',
    }
  },
  addNewUser: {
    position: 'absolute',
    right: '0',
    border: '1px solid #333',
    padding: '5px 25px',
    color: '#333',
    textDecoration: 'none',
    borderRadius: '5px',
    top: '0px',
    marginRight: '6px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt !important',
      marginTop: '-15px',
    },
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    },
  },
  tdLink: {
    color: '#24618E',
  },
  crossCursor: {
    color: '#24618d',
    fontSize: '14pt',
    fontFamily: 'Avenir_Black',
    fontWeight: '800',
    position: 'absolute',
    width: '30px !important',
    right: '0px',
    cursor: 'pointer'
  },
  errMsg: {    
    color: '#CC0000',
    margin: '3px'
  },
}));
//Css code end ...

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

//Start AllUsers component code ....
const AllUsers = props => {
  let history = useHistory();
  const classes = useStyles();
  const [userList, setUserList] = React.useState([]);
  const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
  const [totalItems, setTotalItems] = React.useState(0);
  const [userAccess, setUserAccess] = React.useState(true);
  const [hover, setHower] = React.useState(false);
  const [getSearchTerm, setSearchTerm] = React.useState("");
  const [getLoader, setLoaderDisable] = React.useState(false);
  const [errSearchValue, setErrSearchValue] = React.useState(null);
  const refContainer = useRef('');
  const enteriesPerPage = 25;
  let values = {
    "pageNo": pagination.selectedPage,
    "entriesPerPage": enteriesPerPage,
  }
  useEffect(
    () => {
      getUsersAPI();
    }, []
  )


 // This method is use get all user information for table data .... start
  const getUsersAPI = (page = 1, search = "", enable = false) => { 
    setLoaderDisable(true);
    try {
      axios({
        method: 'post',
        data: {
          pageNo: page,
          entriesPerPage: enteriesPerPage,
          searchEnable: enable,
          searchValue: search
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getAllUsersAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            setLoaderDisable(false);
            setUserList(response.data.data.rows);
            setTotalItems(response.data.data.count);
          } else {
            setLoaderDisable(false);
            setUserList([]);
          }

        })
        .catch(async function (error) {
          if (error.response) {
            if (error.response.status && error.response.status == '401') {
              if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('organization');
                clearCookie('atexpiry');
              }
              history.push('/');
            } else if (error.response.data && error.response.data.status && error.response.data.status == 403) {
              setUserAccess(false);
              setLoaderDisable(false);
              setUserList([]);
            } else {
              setLoaderDisable(false);
              setUserList([]);
            }
          } else {
            setLoaderDisable(false);
            setUserList([]);
          }

        })
    } catch (error) {
      console.error(error);
    }
  }
// This method is use get all user information for table data .... end
 
// This method is use for page selction for table data .... start
  const handleSelected = (e, selectedPage) => {
    if (getSearchTerm != '') {
      let page = selectedPage + 1;
      values.pageNo = selectedPage + 1;
      setPagnation({ selectedPage: selectedPage + 1 })
      getUsersAPI(page, getSearchTerm, true)
    } else {
      let page = selectedPage + 1;
      values.pageNo = selectedPage + 1;
      setPagnation({ selectedPage: selectedPage + 1 })
      getUsersAPI(page);
    }
  }
  // This method is use for page selction for table data .... end

  const kekPressSearch = (e) => {    
    if(e.key === 'Enter'){
      e.preventDefault();
      onSearch();
    }    
  }

  const searchField = (e) => {
    setErrSearchValue(null); 
    setHower(true)    
    setSearchTerm(e.target.value);   
    getUsersAPI(1, e.target.value, true)
    setPagnation({ selectedPage: 1 })    
  }

  const onSearch = () => {   
    setErrSearchValue(null);    
    if(getSearchTerm == ''){      
      setErrSearchValue("Please enter a search term.");
      return;
    }
    getUsersAPI(1, getSearchTerm, true)
    setPagnation({ selectedPage: 1 })
  }


  const clearText = () => {
    refContainer.current.reset();
    setErrSearchValue(null); 
    setSearchTerm('');
    getUsersAPI();
  }


  return (
    <div className={classes.filterTable} data-testid="all_user_table">
      <h5 style={{ marginTop: '10px', marginBottom: '-5px' }}>All Users</h5>
      <form ref={refContainer} noValidate autoComplete="off">
        {errSearchValue ? <InputLabel className={classes.errMsg} htmlFor="input-with-icon-textfield">{errSearchValue}</InputLabel> : null}
        <TextField
          id="input-with-icon-textfield"
          placeholder="Search"
          onChange={(e) => searchField(e)}
          onKeyPress={(e) => kekPressSearch(e)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" onClick={onSearch}>
                <SearchIcon style={{ cursor: 'pointer' }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {hover && <FontAwesomeIcon icon={faTimes} className={classes.crossCursor} onClick={clearText} />}
              </InputAdornment>
            ),
          }}

        />      
        
      </form>
      <MaterialTable
        icons={tableIcons}
        title={userAccess == true ? <NavLink to="#" className={classes.addNewUser} onClick={props.tabuserValue} data-testid="add_new_user_btn">Add New User</NavLink> : null}
        columns={[
          {
            title: '', field: 'new', cellStyle: {
              width: '6%',
              textAlign: 'center',
            },
            render: rowData => <div>{rowData.new_user == true ? 'NEW' : null}</div>,
            headerStyle: {
              width: '6%',
            }
          },
          {
            title: 'Name', field: 'first_name',
            render: rowData => <NavLink to="#" className={classes.tdLink} onClick={() => { props.updateUD(rowData.user_id) }}>{rowData.first_name + ' ' + rowData.last_name}</NavLink>,
          },
          { title: 'Email', field: 'email' },
          { title: 'Organization', field: 'organization' },

        ]}
        data={userList ? userList : []}
        totalCount={totalItems}
        options={{
          filtering: false,
          search: false,
          sorting: false,
          // paging: true,
          paging: totalItems > 25 ? true : false,
          pageSize: enteriesPerPage,
          pageSizeOptions: [0],
          emptyRowsWhenPaging: false,
          maxBodyHeight: sessionStorage.getItem('umTabWidth') >= 3501 ? (sessionStorage.getItem('umTabHeight') - 440).toString() + 'px' : (sessionStorage.getItem('umTabHeight') - 335).toString() + 'px',
        }}
        // components={
        //   userAccess == true ?
        //     {
        //       Pagination: props => (
        //         <TablePagination
        //           {...props}
        //           count={totalItems}
        //           page={pagination.selectedPage - 1}
        //           onChangePage={handleSelected}
        //           rowsPerPage={enteriesPerPage}
        //         />
        //       )
        //     } : {
        //       Pagination: props => (
        //         <TablePagination
        //           {...props}
        //           count={totalItems}
        //           page={pagination.selectedPage - 1}
        //           onChangePage={handleSelected}
        //           rowsPerPage={enteriesPerPage}
        //         />
        //       ),
        //       Body: (props) => (
        //         <tr style={{ height: ' 49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</td></tr>
        //       )
        //     }
        // }
        components={
          userAccess == true ?
            // userList.length > 0 ?
            getLoader == false ?
              {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
              }
              :
              {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
                Body: (props) => (
                  <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress /></span> </td></tr></tbody>
                )
              }
            : {
              Pagination: props => (
                <TablePagination
                  {...props}
                  count={totalItems}
                  page={pagination.selectedPage - 1}
                  onChangePage={handleSelected}
                  rowsPerPage={enteriesPerPage}
                />
              ),
              Body: (props) => (
                <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
              )
            }
        }
      />
    </div>
  )
}

export default AllUsers;
//End AllUsers component code ....